export function subscribeForm() {
    $(window).on("load", function () {
        let $form = $('.subscribe-form form');
        let $resultElement = $('.subscribe-results');

        let email = $('#mce-EMAIL');
        let error_email = email.parent().find('.error');

        function isValidEmail(email) {
            if (!email || !email.length) {
                return false;

            } else {
                let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            }
        }

        function check_email($email) {
            if (!isValidEmail($email)) {
                error_email.addClass('visible');
            } else {
                error_email.removeClass('visible');
            }
        }

        function submitSubscribeForm($form, $resultElement) {
            $.ajax({
                type: "GET",
                url: $form.attr("action"),
                data: $form.serialize(),
                cache: false,
                dataType: "jsonp",
                jsonp: "c", // trigger MailChimp to return a JSONP response
                contentType: "application/json; charset=utf-8",
                beforeSend: function () {
                    $form.find('.button').attr('disabled', 'disabled');
                },
                success: function (data) {
                    if (data.result != "success") {
                        let message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
                        if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                            message = "You're already subscribed. Thank you.";
                        }
                        $resultElement.html(message);
                    } else {
                        //success class
                        $resultElement.html("Please confirm the subscription in your inbox.");
                        email.val('');
                    }
                },
                complete: function () {
                    $form.find('.button').removeAttr('disabled');
                }
            });
        }

        email.on('input', function () {
            check_email($(this).val());
        });

        $form.submit(function (e) {
            e.preventDefault();

            $resultElement.html();

            check_email(email.val());

            if ($(this).find('.error.visible').length === 0) {
                submitSubscribeForm($form, $resultElement);
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/subscribeForm.js